import { Injectable } from '@angular/core';
import { AppService } from '../@core/service/App.Service';
import { ISubscriptionInput } from '@common/models/subscription/subscription.model';
import { HttpClient } from '@angular/common/http';
import { baseProjection } from '@common/projection/base.projection';

@Injectable({ providedIn: 'root' })
export class SubscriptionService extends AppService<any> {
  constructor(private http: HttpClient) {
    super('Subscription');
  }

  async getAllSubscription() {
    return await this.get('/getAllSubscription');
  }

  async getSubscriptionById(subscriptionId: Number) {
    return await this.get(`/getSubscriptionById/${subscriptionId}`);
  }

  async getSubscriptionByCompany<T extends baseProjection>(type: T, companyId: string) {
    return await this.get(`/getSubscriptionByCompany/${companyId}`, null, { projection: type.name });
  }

  async getSubscriptionByStatus<T extends baseProjection>(type: T, companyId: string, status: Number[]) {
    return await this.get(`/getSubscriptionByStatus/${companyId}/${status.toString()}`, null, { projection: type.name });
  }

  async getSubscriptionUsageData<T extends baseProjection>(type: T, companyId: string) {
    return await this.get(`/getSubscriptionUsageData/${companyId}`, null, { projection: type.name });
  }
  

  async addSubscription(subscription: ISubscriptionInput) {
    return await this.post('/addSubscription', subscription);
  }

  async addBulkSubscription(subscription: ISubscriptionInput[]) {
    return await this.post('/addBulkSubscription', subscription);
  }

  async proceedToCheckout(data: any) {
    return await this.post("/proceedToCheckout", data);
  }

  async proceedToTrial(data: any){
    return await this.post("/proceedToTrial", data);
  }

  async updateSubscription(subscription: ISubscriptionInput, subscriptionId: any) {
    return await this.put(
      `/updateSubscription/${subscriptionId}`,
      subscription
    );
  }

  async validateSubscription(companyId: string, option: string, activation:boolean, orderCount: number = 1) {
    const result = await this.get(`/validateSubscription/${companyId}/${option}/${activation}/${orderCount}`);
    let data: any = {
      flag: result.Data,
      msg: option+" limit exceeded! Please upgrade your plan to proceed.",
    };
    return data;
  }
}
